import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import Card from '../Card';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
      {/* <MenuItem
        onClick={() => {
          history.push(routesUrls.presentations)
        }}
      >{formatMessage('navTitleCard')}</MenuItem> */}
   </React.Fragment>
  }
}

const CardPage = (props) => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <Card {...props} />
  </Wrapper>
}

export default CardPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/CardPage.js